import type * as React from "react";

import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
} from "@krea/shared/design-system/sidebar";

import { AppSidebarHeader } from "./app-sidebar-header";
import { NavAdmin } from "./nav-admin";
import { NavLenderApplications } from "./nav-lender-applications";
import { NavSecondary } from "./nav-secondary";
import { NavUser } from "./nav-user";

export const AppSidebar = ({
  ...props
}: React.ComponentProps<typeof Sidebar>) => {
  return (
    <Sidebar variant="inset" {...props}>
      <AppSidebarHeader />
      <SidebarContent>
        <NavLenderApplications />
        <NavAdmin />

        <NavSecondary className="mt-auto" />
      </SidebarContent>
      <SidebarFooter>
        <NavUser />
      </SidebarFooter>
    </Sidebar>
  );
};
